<div id="glazing-layout-draw" #parent>
<icc-draw [details]="drawService.details" [options]="drawOptions" fitTo="height" iccDrawResize [drawWidth]="drawService.details.width" [drawHeight]="drawService.details.height" [parentElement]="parent"></icc-draw>
</div>
